import { createSlice } from "@reduxjs/toolkit";
import {
    addStaffDetails,
    getStaffData,
    getSupplierData,
    addSupplierDetails,
    addDockDetails,
    getBoatData,
    addBoatDetails,
    getDockData,
    updateDocksDetails,
    getAvailableBoats,
    updateSupplierDetails,
    updateBoatDetails,
    getActiveStaffData,
    getTomorrowTasks,
    assignBoatToDock,
    getStaffTasks,
    getAllInvoicedData,
    getAllListInvoiceData,
    deleteDock,
    fetchTechnicianData,
    deleteTechnician,
    deleteSupplier,
    fetchSupplierData,
    fetchSupplierBoatsData,
    toggleTechnicianStatus,
    toggleSupplierStatus,
    getOwnersList,
    fetchRoleCategories
} from "../actions/staffActions";

const initialState = {
    isLoading1: false,
    staff_data: [],
    technicianData: [],
    supplier_data: [],
    staff_active_data: [],
    all_boats: [],
    all_docks: [],
    summary: {},
    available_boats: [],
    tomorrow_task: [],
    staff_task: [],
    all_invoice: [],
    list_invoice_data: [],
    staff_dropdown_data: [],
    owners_list: [],
    supplier_boats_data: {},
};

export const staffSlice = createSlice({
    name: "Auth",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        // addStaffDetails
        builder.addCase(addStaffDetails.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(addStaffDetails.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(addStaffDetails.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getStaffData
        builder.addCase(getStaffData.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getStaffData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.staff_data = data ?? []
            state.isLoading1 = false;
        });
        builder.addCase(getStaffData.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getStaffData
        builder.addCase(fetchRoleCategories.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(fetchRoleCategories.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.roleOptions = data?.map((item) => ({
                label: item?.name ?? "",
                value: item?.id,
            })) ?? [];
            state.isLoading1 = false;
        });
        builder.addCase(fetchRoleCategories.rejected, (state, action) => {
            state.isLoading1 = false;
        });
        // fetch-technicianData
        builder.addCase(fetchTechnicianData.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(fetchTechnicianData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.technicianData = data ?? []
            state.isLoading1 = false;
        });
        builder.addCase(fetchTechnicianData.rejected, (state, action) => {
            state.isLoading1 = false;
        });
        // fetch-supplierData
        builder.addCase(fetchSupplierData.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(fetchSupplierData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.supplierData = data ?? []
            state.isLoading1 = false;
        });
        builder.addCase(fetchSupplierData.rejected, (state, action) => {
            state.isLoading1 = false;
        });
        // fetch-supplier-boats
        builder.addCase(fetchSupplierBoatsData.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(fetchSupplierBoatsData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.supplier_boats_data = data ?? {}
            state.isLoading1 = false;
        });
        builder.addCase(fetchSupplierBoatsData.rejected, (state, action) => {
            state.isLoading1 = false;
        });
        // delete-technician
        builder.addCase(deleteTechnician.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(deleteTechnician.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(deleteTechnician.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // toggle-technician-status
        builder.addCase(toggleTechnicianStatus.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(toggleTechnicianStatus.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(toggleTechnicianStatus.rejected, (state, action) => {
            state.isLoading1 = false;
        });
        // toggle-supplier-status
        builder.addCase(toggleSupplierStatus.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(toggleSupplierStatus.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(toggleSupplierStatus.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getActiveStaffData
        builder.addCase(getActiveStaffData.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getActiveStaffData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.staff_active_data = data ?? []
            state.isLoading1 = false;
        });
        builder.addCase(getActiveStaffData.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getSupplierData
        builder.addCase(getSupplierData.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getSupplierData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.supplier_data = data ?? []
            let value = [
                { value: "all", label: "Select All" }
            ];
            data?.map((item) => (
                value.push({
                    value: item?.id,
                    label: item?.company_name || item?.name || item?.email
                })
            ));
            state.staff_dropdown_data = value;
            state.isLoading1 = false;
        });
        builder.addCase(getSupplierData.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // addSupplierDetails
        builder.addCase(addSupplierDetails.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(addSupplierDetails.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(addSupplierDetails.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // addDockDetails
        builder.addCase(addDockDetails.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(addDockDetails.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(addDockDetails.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // deleteSupplier
        builder.addCase(deleteSupplier.pending, (state) => {
            state.isLoading1 = true;
        });
        builder.addCase(deleteSupplier.fulfilled, (state, action) => {
            const deletedId = Number(action?.meta?.arg?.payload);
            if (Number.isFinite(deletedId)) {
                state.supplier_data = (state.supplier_data ?? []).filter((item) => {
                    const itemId = Number(item?.id);
                    const supplierId = Number(item?.supplier?.id);
                    return itemId !== deletedId && supplierId !== deletedId;
                });

                state.staff_dropdown_data = (state.staff_dropdown_data ?? []).filter((opt) => {
                    if (opt?.value === "all") return true;
                    return Number(opt?.value) !== deletedId;
                });
            }
            state.isLoading1 = false;
        });
        builder.addCase(deleteSupplier.rejected, (state) => {
            state.isLoading1 = false;
        });

        // delete-dock
        builder.addCase(deleteDock.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(deleteDock.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(deleteDock.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getBoatData
        builder.addCase(getBoatData.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getBoatData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.all_boats = data ?? []
            state.isLoading1 = false;
        });
        builder.addCase(getBoatData.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // addBoatDetails
        builder.addCase(addBoatDetails.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(addBoatDetails.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(addBoatDetails.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getDockData
        builder.addCase(getDockData.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getDockData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.all_docks = data?.docks ?? []
            state.summary = data?.summary ?? []
            state.isLoading1 = false;
        });
        builder.addCase(getDockData.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // updateDocksDetails
        builder.addCase(updateDocksDetails.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(updateDocksDetails.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(updateDocksDetails.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getAvailableBoats
        builder.addCase(getAvailableBoats.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getAvailableBoats.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.available_boats = data ?? []
            state.isLoading1 = false;
        });
        builder.addCase(getAvailableBoats.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // updateSupplierDetails
        builder.addCase(updateSupplierDetails.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(updateSupplierDetails.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(updateSupplierDetails.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // updateBoatDetails
        builder.addCase(updateBoatDetails.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(updateBoatDetails.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(updateBoatDetails.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getTomorrowTasks
        builder.addCase(getTomorrowTasks.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getTomorrowTasks.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.tomorrow_task = data ?? []
            state.isLoading1 = false;
        });
        builder.addCase(getTomorrowTasks.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // assignBoatToDock
        builder.addCase(assignBoatToDock.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(assignBoatToDock.fulfilled, (state, action) => {
            state.isLoading1 = false;
        });
        builder.addCase(assignBoatToDock.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getStaffTasks
        builder.addCase(getStaffTasks.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getStaffTasks.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.staff_task = data?.staffMembers ?? []
            state.isLoading1 = false;
        });
        builder.addCase(getStaffTasks.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getAllInvoicedData
        builder.addCase(getAllInvoicedData.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getAllInvoicedData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.all_invoice = data ?? []
            state.isLoading1 = false;
        });
        builder.addCase(getAllInvoicedData.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        // getAllListInvoiceData
        builder.addCase(getAllListInvoiceData.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getAllListInvoiceData.fulfilled, (state, action) => {
            const { data } = action?.payload || [];
            state.list_invoice_data = data ?? []
            state.isLoading1 = false;
        });
        builder.addCase(getAllListInvoiceData.rejected, (state, action) => {
            state.isLoading1 = false;
        });

        //getowner'slist
        // getOwnersList
        builder.addCase(getOwnersList.pending, (state, action) => {
            state.isLoading1 = true;
        });
        builder.addCase(getOwnersList.fulfilled, (state, action) => {
            state.owners_list = action?.payload?.data || [];
            state.isLoading1 = false;
        });
        builder.addCase(getOwnersList.rejected, (state, action) => {
            state.isLoading1 = false;
        });
    },
});

export default staffSlice.reducer;
